import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Navigate } from 'react-router-dom'

/**
 * Guards admin-only pages. A non-admin who types /admin (or /site-content, /coupons)
 * is redirected to their home instead of rendering the admin shell. Admin status is
 * server-authoritative (GET /api/v1/admin/me → { isAdmin }, gated by ADMIN_EMAILS).
 * The underlying admin APIs are already requireAdmin (403); this closes the UI gap.
 */
export default function RequireAdmin({ children }) {
  const [state, setState] = useState('loading') // 'loading' | 'ok' | 'deny'
  useEffect(() => {
    let alive = true
    axios.get('/api/v1/admin/me')
      .then((r) => { if (alive) setState(r.data?.isAdmin ? 'ok' : 'deny') })
      .catch(() => { if (alive) setState('deny') })
    return () => { alive = false }
  }, [])
  if (state === 'loading') return null
  if (state === 'deny') return <Navigate to="/" replace />
  return children
}
